<div class="home-page">
  <section class="hero-section">
    <div class="hero-shell">
      <header class="hero-topbar">
        <a class="hero-brand" href="/home" aria-label="Retour à l'accueil">
          <img
            class="hero-brand-logo"
            [src]="school.logoPath"
            [alt]="school.logoAlt">
        </a>

        <nav class="hero-nav" aria-label="Navigation principale">
          <a href="#formules">Nos formules</a>
          <a href="#documents">Documents</a>
          <a href="#pre-inscription">Pré-inscription</a>
          <a [href]="'tel:' + school.phoneLink">Contact</a>
        </nav>

        <div class="hero-topbar-actions">
          <a
            class="hero-topbar-link"
            href="/home">
            Accueil
          </a>

          <a
            class="hero-topbar-link hero-topbar-link--primary"
            href="/login">
            Connexion
          </a>
        </div>
      </header>

      <div class="hero-main">
        <div class="hero-copy">
          <div class="hero-kicker">
            <span>{{ school.shortName }}</span>
            <small>{{ school.city }} et ses environs</small>
          </div>

          <h1>
            Votre permis,
            <strong>en toute confiance</strong>
          </h1>

          <p class="hero-lead">
            Choisissez une formule simple, préparez votre dossier et avancez à votre rythme.
            Notre équipe vous accompagne du code jusqu’à l’examen.
          </p>

          <div class="hero-actions">
            <a
              class="btn btn-primary btn-lg hero-primary-btn"
              href="#pre-inscription">
              <span class="hero-primary-icon" aria-hidden="true">▱</span>
              <span>Se pré-inscrire</span>
              <span aria-hidden="true">→</span>
            </a>

            <a
              class="hero-call-btn"
              [href]="'tel:' + school.phoneLink">
              <span class="hero-call-icon" aria-hidden="true">☎</span>
              <span class="hero-call-content">
                <strong>Appeler l'agence</strong>
                <small>{{ school.phoneDisplay }}</small>
              </span>
            </a>
          </div>

          <div class="hero-highlights">
            <article class="highlight-card" *ngFor="let highlight of heroHighlights">
              <div class="highlight-icon" aria-hidden="true">●</div>
              <div>
                <h3>{{ highlight.title }}</h3>
                <p>{{ highlight.description }}</p>
              </div>
            </article>
          </div>
        </div>

        <div class="hero-visual">
          <img
            class="hero-scene"
            [src]="heroImagePath"
            [alt]="heroImageAlt">

          <aside class="school-card hero-school-card">
            <div class="school-card-header">
              <p class="school-eyebrow">Votre agence</p>
              <h2>{{ school.name }}</h2>
              <p>Un accueil simple et rapide à {{ school.city }}</p>
            </div>

            <div class="school-info-row">
              <span class="school-info-icon" aria-hidden="true">📍</span>
              <div>
                <small>Adresse</small>
                <strong>{{ fullAddress }}</strong>
              </div>
            </div>

            <div class="school-info-row">
              <span class="school-info-icon" aria-hidden="true">☎</span>
              <div>
                <small>Téléphone</small>
                <a [href]="'tel:' + school.phoneLink">{{ school.phoneDisplay }}</a>
              </div>
            </div>

            <div class="school-info-row">
              <span class="school-info-icon" aria-hidden="true">▤</span>
              <div>
                <small>Agrément</small>
                <strong>{{ school.approvalNumber }}</strong>
              </div>
            </div>

            <div class="school-separator"></div>

            <div class="school-note">
              <div class="school-note-icon" aria-hidden="true">◷</div>
              <div>
                <strong>Besoin d'aide ?</strong>
                <p>
                  Passez en agence ou appelez-nous pour choisir la bonne formule et compléter votre dossier.
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>

      <div class="hero-bottom-strip">
        <div class="hero-bottom-item">
          <span class="hero-bottom-icon" aria-hidden="true">★</span>
          <span>Une équipe locale<br>à votre écoute</span>
        </div>

        <div class="hero-bottom-item">
          <span class="hero-bottom-icon" aria-hidden="true">📍</span>
          <span>Un accompagnement<br>jusqu’à l’examen</span>
        </div>
      </div>
    </div>
  </section>

  <section class="formulas-section" id="formules">
    <div class="formulas-container">
      <div class="formulas-heading section-heading">
        <span class="section-badge">Nos formules</span>
        <h2>Les formules classiques, manuelle ou automatique</h2>
        <p>
          D'autres formules sont disponibles en agence.
        </p>
      </div>

      <div
        class="alert alert-danger"
        role="alert"
        *ngIf="messageError">
        {{ messageError }}
      </div>

      <div class="formulas-grid" *ngIf="formulas.length > 0; else noFormulas">
        <article
          class="formula-card"
          *ngFor="let formula of formulas; trackBy: trackByFormulaId"
          [class.formula-card-selected]="isFormulaSelected(formula.id)">
          <div class="formula-card-top">
            <span class="formula-badge">Formation</span>
            <span class="formula-tag">{{ formula.subtitle }}</span>
          </div>

          <h3>{{ formula.label }}</h3>

          <div class="formula-price-main">
            <span>Tarif</span>
            <strong>{{ formula.price }} €</strong>
          </div>

          <ul class="formula-features">
            <li *ngFor="let feature of formula.features">
              <span class="formula-feature-check" aria-hidden="true">✓</span>
              <span>{{ feature }}</span>
            </li>
          </ul>

          <button
            type="button"
            class="btn btn-outline-primary formula-action"
            (click)="selectFormula(formula.id)">
            {{ isFormulaSelected(formula.id) ? 'Formule sélectionnée' : 'Choisir cette formule' }}
          </button>
        </article>
      </div>

      <ng-template #noFormulas>
        <div class="empty-state">
          Aucune formule n'est configurée pour cette auto-école.
        </div>
      </ng-template>
    </div>
  </section>

  <section class="registration-section" id="documents">
    <div class="container">
      <div class="registration-layout">
        <aside class="registration-sidebar">
          <article class="panel-card documents-card">
            <div class="section-heading">
              <span class="section-badge">Infos pratiques</span>
              <h2>Documents d'inscription</h2>
              <p>Préparez ces pièces avant votre passage en agence.</p>
            </div>

            <ul class="documents-list">
              <li *ngFor="let documentItem of requiredDocuments">
                <span class="document-check" aria-hidden="true">✓</span>
                <span>{{ documentItem }}</span>
              </li>
            </ul>
          </article>

          <article class="panel-card appointment-card">
            <span class="section-badge">Rendez-vous agence</span>
            <h3>Un dossier prêt plus vite</h3>
            <p>
              Une fois la demande envoyée, vous pouvez vous rendre en agence pour finaliser votre inscription.
            </p>

            <div class="appointment-contact">
              <strong>{{ school.name }}</strong>
              <span>{{ fullAddress }}</span>
              <a [href]="'tel:' + school.phoneLink">{{ school.phoneDisplay }}</a>
            </div>
          </article>
        </aside>

        <article class="registration-shell" id="pre-inscription">
          <div class="registration-header">
            <div>
              <span class="registration-badge">Pré-inscription</span>
              <h2>Commencer un dossier</h2>
              <p>Remplissez les informations de l'élève pour envoyer une demande à l'agence.</p>
            </div>

            <ng-container *ngIf="selectedFormula as activeFormula; else noSelectedFormula">
              <div class="registration-chip-list">
                <span>{{ activeFormula.label }}</span>
                <span>{{ activeFormula.subtitle }}</span>
              </div>
            </ng-container>

            <ng-template #noSelectedFormula>
              <div class="registration-chip-list">
                <span>Choisissez une formule</span>
                <span>Manuelle ou automatique</span>
              </div>
            </ng-template>
          </div>

          <div
            class="alert alert-danger"
            role="alert"
            *ngIf="messageError">
            {{ messageError }}
          </div>

          <form
            class="registration-form"
            [formGroup]="initStudentForm"
            (ngSubmit)="isSubmited(initStudentForm)"
            novalidate>
            <h3 class="form-section-title">Informations de l'élève</h3>

            <fieldset class="choice-fieldset mb-3">
              <legend>Civilité</legend>
              <div class="choice-row">
                <label class="form-check form-check-inline mb-0">
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="sexe"
                    value="F">
                  <span class="form-check-label">Madame</span>
                </label>

                <label class="form-check form-check-inline mb-0">
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="sexe"
                    value="M">
                  <span class="form-check-label">Monsieur</span>
                </label>
              </div>
            </fieldset>

            <div class="form-group">
              <label for="formulaId">Formule</label>
              <select
                id="formulaId"
                class="form-control"
                formControlName="formulaId">
                <option [ngValue]="null">Choisissez une formule</option>
                <option *ngFor="let formula of formulas" [ngValue]="formula.id">
                  {{ formula.label }} - {{ formula.price }} €
                </option>
              </select>
              <small class="p-alert" *ngIf="submited && initStudentForm.get('formulaId')?.errors?.required">
                Merci de choisir une formule.
              </small>
            </div>

            <div class="row">
              <div class="col-md-4 form-group">
                <label for="neph">NEPH</label>
                <input
                  id="neph"
                  type="text"
                  class="form-control"
                  formControlName="neph"
                  placeholder="Numéro NEPH">
              </div>

              <div class="col-md-4 form-group">
                <label for="lastname">Nom</label>
                <input
                  id="lastname"
                  type="text"
                  class="form-control"
                  formControlName="lastname"
                  placeholder="Nom">
                <small class="p-alert" *ngIf="submited && initStudentForm.get('lastname')?.errors?.required">
                  Merci de définir le nom.
                </small>
              </div>

              <div class="col-md-4 form-group">
                <label for="firstname">Prénom</label>
                <input
                  id="firstname"
                  type="text"
                  class="form-control"
                  formControlName="firstname"
                  placeholder="Prénom">
                <small class="p-alert" *ngIf="submited && initStudentForm.get('firstname')?.errors?.required">
                  Merci de définir le prénom.
                </small>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label for="email">Email</label>
                <input
                  id="email"
                  type="email"
                  class="form-control"
                  formControlName="email"
                  placeholder="Email">
                <small class="p-alert" *ngIf="submited && initStudentForm.get('email')?.errors?.required">
                  Merci de définir l'email.
                </small>
                <small class="p-alert" *ngIf="submited && initStudentForm.get('email')?.errors?.email">
                  Email invalide.
                </small>
              </div>

              <div class="col-md-6 form-group">
                <label for="birthDate">Date de naissance</label>
                <input
                  id="birthDate"
                  type="date"
                  class="form-control"
                  formControlName="birthDate">
                <small class="p-alert" *ngIf="submited && initStudentForm.get('birthDate')?.errors?.required">
                  Merci de définir la date de naissance.
                </small>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label for="birthPlace">Lieu de naissance</label>
                <input
                  id="birthPlace"
                  type="text"
                  class="form-control"
                  formControlName="birthPlace"
                  placeholder="Lieu de naissance">
                <small class="p-alert" *ngIf="submited && initStudentForm.get('birthPlace')?.errors?.required">
                  Merci de définir le lieu de naissance.
                </small>
              </div>

              <div class="col-md-6 form-group">
                <label for="phoneNumber">Téléphone</label>
                <input
                  id="phoneNumber"
                  type="tel"
                  class="form-control"
                  formControlName="phoneNumber"
                  placeholder="0XXXXXXXXX">
                <small class="p-alert" *ngIf="submited && initStudentForm.get('phoneNumber')?.errors?.required">
                  Merci de définir un numéro de téléphone valide.
                </small>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8 form-group">
                <label for="address">Adresse</label>
                <input
                  id="address"
                  type="text"
                  class="form-control"
                  formControlName="address"
                  placeholder="Adresse">
                <small class="p-alert" *ngIf="submited && initStudentForm.get('address')?.errors?.required">
                  Merci de définir l'adresse.
                </small>
              </div>

              <div class="col-md-4 form-group">
                <label for="postalCode">Code postal</label>
                <input
                  id="postalCode"
                  type="text"
                  class="form-control"
                  formControlName="postalCode"
                  placeholder="Code postal">
                <small class="p-alert" *ngIf="submited && initStudentForm.get('postalCode')?.errors?.required">
                  Merci de définir le code postal.
                </small>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 form-group">
                <label for="city">Ville</label>
                <input
                  id="city"
                  type="text"
                  class="form-control"
                  formControlName="city"
                  placeholder="Ville">
                <small class="p-alert" *ngIf="submited && initStudentForm.get('city')?.errors?.required">
                  Merci de définir la ville.
                </small>
              </div>

              <div class="col-md-6 form-group">
                <label for="registrationDate">Date d'inscription</label>
                <input
                  id="registrationDate"
                  type="date"
                  class="form-control"
                  formControlName="registrationDate">
              </div>
            </div>

            <div class="registration-footer">
              <button
                type="submit"
                class="btn btn-primary"
                [disabled]="sending">
                {{ sending ? 'Envoi en cours...' : 'Envoyer la pré-inscription' }}
              </button>
            </div>
          </form>
        </article>
      </div>
    </div>
  </section>

  <div
    class="modal fade"
    id="modal-send-validated"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modal-send-validated-title"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body text-center">
          <h4 id="modal-send-validated-title" class="mb-3">Votre pré-inscription est envoyée !</h4>
          <p class="mb-4">
            Rendez-vous en agence pour finaliser votre dossier chez {{ school.name }}.
          </p>

          <button
            type="button"
            class="btn btn-primary"
            data-dismiss="modal">
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
